import React from "react"
import { Button } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { Link } from "react-router"
import Authenticated from "../../../lib/Authenticated"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { Currencies, validateAmountState, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FieldGroup from "../../fragments/FieldGroup"
import FieldGroupSelect from "../../fragments/FieldGroupSelect"
import ProcessesStatus from "../../fragments/ProcessesStatus"

class CurrencyRateForm extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    running: false,
    success: false,
    error: null,
    rate: 1,
    from: '',
    fromIsEdited: false,
    rateIsEdited: false,
    validateRateSate: VALIDATION_TYPE.SUCCESS,
    validateFromState: VALIDATION_TYPE.NULL,
    showForm: true,
  }

  getUpdateBaseCurrencyLink = () => <Link to={`/settings/base-currency`} title="Change">
    <FontAwesome name="pencil" title='Update' /> Change</Link>

  rateChanged = rate => this.setState({
    rate,
    validateRateSate: validateAmountState(rate, false),
    rateIsEdited: true,
    error: null,
  })

  fromChanged = from => this.setState({
    from,
    validateFromState: validateTextState(from, false),
    fromIsEdited: true,
    error: null,
  })

  saveClicked = () => {

    const { rate, from } = this.state,
      { baseCurrencyCode, currencyDataChanged } = this.props,
      validateRateSate = validateAmountState(rate, false),
      validateFromState = validateTextState(from, false)

    if (validateRateSate !== VALIDATION_TYPE.SUCCESS || validateFromState !== VALIDATION_TYPE.SUCCESS) {
      this.setState({
        validateRateSate,
        validateFromState,
        error: 'Invalid data' 
      })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })
    const data = { from, to: baseCurrencyCode, rate }

    blockingFetchService(
      accessToken => apiServerApi.saveCurrencyRate(accessToken, data),
      _ => {
        this.setState({
          success: true,
          fromIsEdited: false,
          rateIsEdited: false
        })
        currencyDataChanged()
        setTimeout(() => this.setState({ success: false }), 2000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderContent = () => {

    const { baseCurrencyCode } = this.props,
    { from, rate, validateRateSate, validateFromState, running, success, error,
      rateIsEdited, fromIsEdited } = this.state,
    filteredCurrencies = Currencies.filter(item => item.value !== baseCurrencyCode)

    return (
      <div>
        <hr />
        <div className="flex-row">

            <FieldGroupSelect
              controlId='from'
              label='From'
              value={ from }
              withEmptyOption={ true }
              onChange={ this.fromChanged }
              options={ filteredCurrencies }
              validationState={ validateFromState }
            />

            <FontAwesome name='exchange' />

            <FieldGroupSelect
              controlId='to'
              label='To'
              value={ baseCurrencyCode }
              options={[{ value: baseCurrencyCode, title: baseCurrencyCode}]}
              disabled={ true }
            />
        </div>

        <FieldGroup
          id="conversionRate"
          type="text"
          label="Conversion rate"
          placeholder="Enter rate"
          validationState={ validateRateSate }
          value={ rate }
          onChange={e => this.rateChanged(e.target.value)}
        />

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <div className="align-right mt-10">
          <Button bsStyle="primary" onClick={ this.saveClicked } className="w-120"
            disabled={ running || !(rateIsEdited || fromIsEdited) }>
            <FontAwesome name='save' /> Save
          </Button>
        </div>
      </div>
    )
  }

  renderHeader = () => {

    const { baseCurrencyCode, choosenCurrencyCode, currentRate } = this.props
    return (
      <div>

        <div className="flex-row">
          <span>Base currency: &nbsp; { baseCurrencyCode }</span>
          { this.isAdmin && this.getUpdateBaseCurrencyLink() }
        </div>

        <p className="mv-10">
          1 { choosenCurrencyCode }  &nbsp; =  &nbsp; { currentRate } { baseCurrencyCode }
        </p>
      </div>
    )
  }

  render() {

    const { showForm } = this.state
    return (
      <div className="simple-form mb-20">

        <span className="flex-row cursor-pointer" onClick={_ => this.setState({ showForm: !showForm })}
          title='Click to toggle view'>
          <strong>Conversion</strong>
          <FontAwesome name={ showForm ? 'chevron-down' : 'chevron-up' } />
        </span>

        <hr />
        { this.renderHeader() }
        { showForm && this.renderContent() }
      </div>
    )
  }
}

export default CurrencyRateForm



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/CurrencyRateForm.js